import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {TypeformPopupButton} from '../components/social/typeform-popup-button';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface MusicSubmissionsPageProps {}

@inject(deps) @observer
export class MusicSubmissionsPage extends Component<MusicSubmissionsPageProps> {
  render() {
    return (
      <PageGenericPrismic model={this.props.model.page.musicSubmissions}>
        <TypeformPopupButton typeformUrl={this.props.model.page.musicSubmissions.typeform_url}>
          {this.props.model.page.musicSubmissions.typeform_button_label}
        </TypeformPopupButton>
      </PageGenericPrismic>
    )
  }
}